const content: { [key: string]: any } = {
  pageTitle: "Earnings Calculator",
  trainingMode: "Training Mode",
  notQualified: "Not Qualified",
  dashboardTile: {
    simulatedEarnings: "Simulated Earnings",
    seeBonusDetails: "See Bonus Details",
  },
  incomeBreakdownTile: {
    title: "Income Breakdown",
    monthlyBonus: "Monthly Bonus",
    monthlyBonusSubtotal: "Monthly Bonus Subtotal",
    close: "Close",
    performanceBonusTotal: {
      title: "Performance Bonus Total",
      personal: "Personal",
      differential: "Differential",
      personalMultiplier: {
        basis: "Personal BV",
        multiplier: "Performance Bonus %",
        bonus: "Personal Performance Bonus",
      },
      differentialMultiplier: {
        basis: "Leg {count} Group BV",
        multiplier: "Difference in Performance Bonus %",
        bonus: "Differential Bonus",
      },
    },
    csi: {
      title: "CSI+",
      basis: "Verified Customer Sales BV",
      multiplier: "Customer Sales Incentive+%",
    },
    bronze: {
      noOfMonths: "{noOfMonths} Months",
      consistency: "Consistency",
      performanceBonus: "Performance Bonus",
      monthsList: "{noOfMonths} months",
      bfi: {
        title: "Bronze Foundation+",
        incentiveMultiplier: "Bronze Foundation+ Incentive Multiplier",
        incentive: "Bronze Foundation+ Incentive",
      },
      bbi: {
        title: "Bronze Builder+",
        incentiveMultiplier: "Bronze Builder+ Incentive Multiplier",
        incentive: "Bronze Builder+ Incentive",
      },
    },
  },
  keyMetrics: {
    personalPv: "Personal PV",
    personalBv: "Personal BV",
    totalGroupPv: "Total Group PV",
    performanceBonusLevel: "Performance Bonus Level",
    vcsPv: "VCS PV",
  },
  progressTile: {
    description: "Currently at",
    tooltip: "{requiredPv} {PvType} needed to earn bonus",
    resetValues: "Reset Values",
    inputNumberDesc: "Input a number or move slider",
    pv: "{pv} PV",
    vcsPvSuffix: "VCS PV",
    pvSuffix: "PV",
    inputPlaceholder: "Input a number or move slider",
  },
  aboLegs: {
    title: "ABO Legs",
    description: "Use the tabs below to see how your business can qualify for Bronze Foundation+ or Bronze Builder+.",
    tabs: {
      bronzeFoundation: "Bronze Foundation+ Target",
      bronzeBuilder: "Bronze Builder+ Target",
    },
    learnMore: "Learn More",
    legTile: {
      header: "Leg {legCount}",
      remove: "Remove",
      inputGpvValue: "Input GPV Value",
      gpv: "GPV",
      addAboLeg: "Add ABO Leg",
    },
  },
  toast: {
    title: "Message",
    description: "Your numbers exceed maximum threshold for earning Calculators. They will be set to 0.",
  },
  footer:
    "This Earnings Calculator is provided for purely indicative purposes. Usage shall not be construed as creating either any specific obligation for Amway to provide compensation or an expectation thereto on the part of the Amway Business Owner (ABO). PV/BV and monetary values shown in connection with the Core Plan and Core Plus are estimated only and are subject top adjustment based upon subsequent product returns and other factors. Actual compensation is determined in accordance with the ABO Contract, of which the Core Plan, as it may be renamed by Amway, forms an integral part. Amway reserves the unilateral right to modify, revoke, or limit the usage of this Earnings Calculator. Other terms and conditions may apply.",
  infoSlider: {
    header: "What does this mean?",
    totalEarningTitle: "Total Earnings",
    totalEarningDesc:
      "Estimated total earnings based on entered information, including Performance Bonus and Core Plus⁺ incentives.",
    groupPVTitle: "Group PV",
    groupPVDesc:
      "Monthly volume including ABO's own PV, Customer PV and volume from your downline legs. Your total GPV determines your Performance Bonus level.",
    vcsPVTitle: "VCS PV",
    vcsPVDesc:
      "Verified Customer Sales PV is total volume from customer orders meeting Verified Customer Sales requirements.",
    performanceBonusTypesTitle: "Performance Bonus Types",
    personalPerformanceBonusSubTitle: "Personal Performance Bonus",
    personalPerformanceBonusDesc:
      "Your total Personal BV multiplied by your performance bonus level. Personal PV & BV only comes from what you and your customers purchased.",
    differentialPerformanceBonusSubTitle: "Differential Performance Bonus",
    differentialPerformanceBonusDesc:
      "Differential is earned by taking your performance bonus level and subtracting the performance bonus level of your legs multiplied by the Group BV from the leg. Example: You are at 9% and have a leg at 3%, you earn a 6% differential on the Group BV for that leg.",
    customerSalesIncentiveTitle: "Customer Sales Incentive",
    customerSalesIncentiveDesc:
      "A discretionary incentive that allows you to earn up to {MaxCSIPercent} on customer orders meeting Verified Customer Sales requirements.",
    bronzeFoundationTitle: "Bronze Foundation",
    bronzeFoundationDesc:
      "Bronze Foundation Incentive⁺ requires you to have some personal volume, achieve at least {PerformanceBonusTarget}% on Performance Bonus schedule and have {LegsPercentageTarget} ABO legs who achieve {LegsPercentagePercent}% or more performance bonus.",
    bronzeFoundationConsistencyTitle: "Bronze Foundation Consistency",
    bronzeFoundationConsistencyDesc:
      "Bronze Foundation Consistency requires you to earn a certain number of Bronze Foundation qualified months within your eligibility window which will reward you with an additional incentive.",
    bronzeBuilderTitle: "Bronze Builder",
    bronzeBuilderDesc:
      "Bronze Builder Incentive⁺ requires you to have some personal volume, achieve at least {PerformanceBonusTarget}% on Performance Bonus schedule, and sponsor at least {LegsPercentageTarget} legs who achieve {LegsPercentagePercent}% or more performance bonus.",
    bronzeBuilderConsistencyTitle: "Bronze Builder Consistency",
    bronzeBuilderConsistencyDesc:
      "Bronze Builder Consistency requires you to earn a certain number of Bronze Builder qualified months within your eligibility window which will reward you with an additional incentive.",
    bronzeFoundationRequiredNote:
      "This assumes {VCSBonusLegsTarget} Legs with an ABO with {VCSBonusLegsTargetVCSPV} VCS PV",
    bronzeBuilderRequiredNote:
      "This assumes {VCSBonusLegsTarget} Legs with an ABO with {VCSBonusLegsTargetVCSPV} VCS PV",
  },
};

export default content;
